<template>
  <div>
    <b-button @click="$bvModal.show(id)">Abrir alternativas</b-button>
    <b-modal title="Seleccione que caracteristica filtrar" :id="id" @ok="handleOk">
      <b-button @click.prevent="handleShow" class="pb-2">Desmarcar todo</b-button>
      <hr />
      <b-form-group label="Defectos" label-for="defects">
        <b-form-checkbox-group
          id="defectKeys"
          v-model="selectedDefects"
          :options="defectKeys"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import defects from "../../../../data/defects";
export default {
  name: "FilterOpModal",
  data() {
    return {
      selectedDefects: [],
      defectKeys: Object.keys(defects)
    };
  },
  props: {
    id: {
      type: String,
      default: "filter-op-modal"
    },
    defects: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleShow() {
      this.selectedDefects = [];
    },
    handleOk() {
      this.$emit("ok", this.selectedDefects);
    },
  }
};
</script>

<style></style>
